// Dialogs
function showWorkingDialog(message) {
    return bootbox.dialog({
        message:
            '<p class="text-center"><i class="fa fa-spin fa-spinner m-r-sm"></i><span class="working-dialog-title">' +
            message +
            "</span>...</p>",
        closeButton: false,
    });
}

function updateWorkingDialog(dialog, message) {
    if (dialog) {
        $(".working-dialog-title", dialog).text(message);
    }
}

function hideWorkingDialog(dialog) {
    if (dialog) {
        dialog.modal("hide");
        dialog.on("hide.bs.modal", function () {
            // Manually remove the backdrop
            $(".modal-backdrop").remove();
        });
    }
}

function hideSelectors(selectors) {
    if (typeof selectors === "string") {
        selectors = [selectors];
    }
    for (var i = 0; i < selectors.length; i++) {
        $(selectors[i]).addClass("hidden");
    }
}

function getPageHeaderTitleEl() {
    return $(".page-header-title");
}

function getPageHeaderSubtitleEl() {
    return $(".page-header-subtitle");
}

function comingSoon() {
    showFlash("warning", "This feature is coming soon!");
}

function percentChange(newValue, oldValue) {
    return percentInt(newValue - oldValue, oldValue);
}

function percentInt(numerator, denominator) {
    if (!denominator || denominator === 0) return 0;

    return parseInt((numerator / denominator) * 100);
}

module.exports = {
    showWorkingDialog,
    updateWorkingDialog,
    hideWorkingDialog,
    hideSelectors,
    getPageHeaderTitleEl,
    getPageHeaderSubtitleEl,
    comingSoon,
    percentChange,
    percentInt,
};
